// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"26670648","909":"9d4e5602"}[chunkId] + ".chunk.js";
};